<template>
    <section class="app">
        <div v-if="!isIeBrowser" id="app" class="bg-color">
            <layout-header />
            <router-view class="main-body" />
            <layout-footer />
            <layout-cookie />
            <SideButton v-if="$route.name!=='articlePage'"/>
        </div>
        <div v-else id="app" class="bg-color">
            <div class="my-4 mx-auto p-4 borderStyle">
                <p class="mt-2 mb-0">
                    <AlertTriangleIcon size="1.3x" stroke-width="2" />
                    貼心提醒，為了提供更好的使用者體驗，本站台已不支援Internet
                    Explorer瀏覽器，建議使用最新版本<br />
                </p>
                <p class="mt-2 mb-0 text-center" >
                    Chrome、Firefox、Safari、Edge瀏覽器瀏覽本站台
                </p>
            </div>
        </div>
    </section>
</template>
<script>
import LayoutHeader from '@/components/layout/Header.vue';
import LayoutFooter from '@/components/layout/footer';
import LayoutCookie from '@/components/layout/cookie';
import SideButton from '@/components/layout/SideButton.vue';
import { AlertTriangleIcon } from 'vue-feather-icons';

export default {
    data() {
        return {
            isIeBrowser: false,
        };
    },
    components: {
        'layout-header': LayoutHeader,
        'layout-footer': LayoutFooter,
        'layout-cookie': LayoutCookie,
        AlertTriangleIcon,
        SideButton
    },
    created() {
        this.checkBrowser();
    },
    methods: {
        checkBrowser() {
            const userAgent = window.navigator.userAgent;
            const isIE =
                userAgent.indexOf('MSIE') > 0 ||
                userAgent.indexOf('Trident/') > 0;
            if (isIE) {
                this.isIeBrowser = true;
            } else {
                this.$store.dispatch('getMenu');
            }
        },
    },
};
</script>
<style scoped lang="scss">
.app {
    #app {
        color: $gray-800;
    }
    .main-body {
        margin-top: 58px;
        min-height: calc(100vh - 106px - 138px);
        @include media-breakpoint-up(md) {
            min-height: calc(100vh - 106px - 162px);
            margin-top: 106px;
        }
        @include media-breakpoint-up(lg) {
            min-height: calc(100vh - 106px - 138px);
        }
    }
}
.borderStyle {
    max-width: 64rem;
    border-radius: 10px;
    box-shadow: 2px 2px 24px #ccc;
    color: #666;
    background-color: hsl(53, 92%, 90%);
    font-size: 20px;
    font-weight: 700;
}
.text-center {
  text-align: center;
}
</style>
